import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { Button, Card, CardBody } from '../components/index.js';

export function AccessDenied() {
  return (
    <main className="min-h-screen flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <Card>
          <CardBody>
            <div className="flex flex-col items-center text-center gap-4">
              <span className="inline-flex size-12 items-center justify-center rounded-xl bg-warning/15 text-warning">
                <ShieldAlert className="size-6" aria-hidden />
              </span>
              <h1 className="text-2xl font-bold text-text-primary">Access denied</h1>
              <p className="text-base text-text-secondary">
                Your email is not on the TAS Portal allowlist. Contact your administrator to be added.
              </p>
              <Link to="/" className="w-full">
                <Button fullWidth variant="secondary">Back to sign in</Button>
              </Link>
            </div>
          </CardBody>
        </Card>
      </div>
    </main>
  );
}
